module.exports = __webpack_public_path__ + "static/Hippogriff-151fe2262c0e4b5164bdafbc8546fe64.jpg";